<template lang="pug">
.report-summary
  h1 月汇总报表

  month-select(:start.sync='date_start', :end.sync='date_end')

  table.ui.celled.structured.table.fixed.olive
    thead
        th.center.aligned 房号
        th.center.aligned 住户
        th.center.aligned 租金
        th.center.aligned 押金
        th.center.aligned 预定金
        th.center.aligned 管理费
        th.center.aligned 冷水
        th.center.aligned 热水
        th.center.aligned 电费
        th.center.aligned 其他
        th.center.aligned 汇总
    tbody
      tr(v-for='(row, irow) in data', :class='{summary: irow === data.length - 1}')
        td.right.aligned(v-for='(value, icol) in row', :class='{bold: icol === 10 || icol === 0, negative: (value||"").startsWith("-") && value !== "-" }') {{value}}
</template>

<script>
import MonthSelect from './MonthSelect.vue'

export default {
  name: 'report-summary',
  components: { MonthSelect },
  data() {
    return {
      date_start: this.$moment(),
      date_end: this.$moment(),
      new_data: {},
    }
  },
  mounted() {
    this.$store.dispatch('load_bills')
    // this.load()
  },
  watch: {
    date_end() {
      // this.load()
    },
  },
  methods: {
    load() {
      this.$http
        .get(
          `report/summary/by/month?from=${this.date_start.format()}&to=${this.date_end.format()}`
        )
        .then(data => data.json())
        .then(data => {
          this.new_data = data
        })
    },
  },
  computed: {
    data() {
      const contracts = {}
      for (const bill of this.filtered_bills) {
        const id = bill._contract
        if (!contracts[id])
          contracts[id] = (new Array(10)).fill(0)
        const record = contracts[id]
        if (!record[0])
          record[0] = id ? bill._room : '-'

        const fee = (bill.income_actual || 0) - (bill.outcome_actual || 0)
        if (bill.subject2 === '租金' && bill.subject1 === '主营业务')
          record[1] += fee
        else if (bill.subject2 === '合同押金')
          record[2] += fee
        else if (bill.subject2 === '预定金')
          record[3] += fee
        else if (bill.subject2 === '管理费')
          record[4] += fee
        else if (bill.subject2 === '水电费' && bill.subject3 === '冷水')
          record[5] += fee
        else if (bill.subject2 === '水电费' && bill.subject3 === '热水')
          record[6] += fee
        else if (bill.subject2 === '水电费' && bill.subject3 === '电表')
          record[7] += fee
        else
          record[8] += fee
      }

      const formate_row = (row) => ([
        this.$formatters.money(row[1]),
        this.$formatters.money(row[2]),
        this.$formatters.money(row[3]),
        this.$formatters.money(row[4]),
        this.$formatters.money(row[5]),
        this.$formatters.money(row[6]),
        this.$formatters.money(row[7]),
        this.$formatters.money(row[8]),
        this.$formatters.money(row[1] + row[2] + row[3] + row[4] + row[5] + row[6] + row[7] + row[8]),
      ])

      const summary = (new Array(10)).fill(0)
      for (const record of Object.values(contracts)) {
        for (let i = 1; i < 10; i++)
          summary[i] += (record[i] || 0)
      }

      const results = []
      for (const contract_id of Object.keys(contracts).sort()) {
        const record = contracts[contract_id]
        const room_id = record[0]
        const room_no = (this.$store.getters.room_by_id(room_id) || {}).no || '其他'
        const contract = this.$store.getters.contract(contract_id) || {}
        let customers = []
        if (contract) {
          if (contract._customers && typeof contract._customers[0] === 'string')
            customers = this.$store.getters.customers_filter(contract._customers)
          else
            customers = contract._customers
        }
        const names = this.$formatters.customers_summary(customers)
        results.push([room_no, names].concat(formate_row(record)))
      }

      results.sort((a, b) => a[0] - b[0])

      results.push(['汇总', ''].concat(formate_row(summary)))

      return results
    },
    bills() {
      return this.$store.state.summary.bills
    },
    filtered_bills() {
      return this.bills.filter(c => {
        const time = this.$moment(c.time_created)
        return time < this.date_end && time >= this.date_start && c.state === 'verified'
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// Month.vue?41f61672